import type { ChatComposerProps } from "./ChatComposer";

const noAction = () => {};
const noAsyncAction = async () => {};

/** Live approvals and turn actions become available after thread hydration. */
export const remoteComposerInactiveControls = {
  activeThread: undefined,
  isServerThread: true,
  isLocalDraftThread: false,
  phase: "ready",
  isSendBusy: false,
  isPreparingWorktree: false,
  activePendingApproval: null,
  activeActionRequired: null,
  pendingApprovals: [],
  pendingUserInputs: [],
  activePendingProgress: null,
  activePendingResolvedAnswers: null,
  activePendingIsResponding: false,
  activePendingDraftAnswers: {},
  activePendingQuestionIndex: 0,
  pendingUserInputError: null,
  respondingRequestIds: [],
  showPlanFollowUpPrompt: false,
  activeProposedPlan: null,
  activePlan: null,
  sidebarProposedPlan: null,
  planSidebarLabel: "Plan",
  planSidebarOpen: false,
  lockedProvider: null,
  activeProjectDefaultModelSelection: null,
  activeThreadActivities: undefined,
  keybindings: [],
  gitCwd: null,
  pullRequest: { number: null, state: null, url: null, title: null },
  onInterrupt: noAction,
  onImplementPlanInNewThread: noAction,
  onRespondToApproval: noAsyncAction,
  onRetryGitHubActionRequired: noAsyncAction,
  onSelectActivePendingUserInputOption: noAction,
  onAdvanceActivePendingUserInput: noAction,
  onPreviousActivePendingUserInputQuestion: noAction,
  onChangeActivePendingUserInputCustomAnswer: noAction,
  togglePlanSidebar: noAction,
} satisfies Partial<ChatComposerProps>;
